import { useLocation } from '@tanstack/react-router';
import { useEffect } from 'react';

import { NEW_CHAT_TITLE } from '@/components/ui/window-title/ChatTitle';
import { PanelNavigationTitle } from '@/components/ui/window-title/PanelNavigationTitle';
import { useSetChatWindowTitle } from '@/hooks/useSetChatWindowTitle';
import { uiStore } from '@/stores/ui.store';

function useWindowTitle() {
  const location = useLocation();
  const setChatWindowTitle = useSetChatWindowTitle();

  useEffect(() => {
    const path = location.pathname;
    if (path.includes('/chats')) {
      const threadId = path.split('/').pop();
      setChatWindowTitle({
        threadId: threadId ?? '',
        title: NEW_CHAT_TITLE,
      });
      return;
    }

    uiStore.setWindowTitle({
      title: <PanelNavigationTitle />,
      altTitle: path.split('/').pop()?.toUpperCase() || 'HOME',
    });
  }, [location.pathname, setChatWindowTitle]);

  useEffect(() => {
    setChatWindowTitle({
      threadId: '',
      title: NEW_CHAT_TITLE,
    });
  }, [setChatWindowTitle]);
}

export { useWindowTitle };
